import apiClient from './index';

export interface CampaignDetails {
    id: string;
    code: string;
    name: string;
    description: string;
    facilitator: string;
    created_at: string;
    owner: string | null;
    access_level: string;
}

export async function fetchCampaignDetails(campaignId: string): Promise<CampaignDetails> {
    const { data } = await apiClient.get(`/sigcap/api/campaign-detail/${campaignId}/`);
    return data;
}
